module.exports = __webpack_public_path__ + "media/react/payments/pages/register/assets/smiling_graduate-9ba37ae3e26a29ef328e15a0e58adb72.jpg";